export const WORKFLOW_MODE = Object.freeze({
    EMPTY: 'empty',
    EDITING_INSTRUCTIONS: 'editingInstructions',
    GENERATING: 'generating',
    REVIEWING_STEPS: 'reviewingSteps',
    EDITING_STEP: 'editingStep',
    SAVING: 'saving',
    READY_TO_REPLAY: 'readyToReplay',
    REPLAYING: 'replaying',
    REVIEWING_RESULTS: 'reviewingResults',
    ERROR: 'error',
});

export const RUN_STATUS = Object.freeze({
    IDLE: 'idle',
    CONNECTING: 'connecting',
    RUNNING: 'running',
    STOPPING: 'stopping',
    COMPLETED: 'completed',
    FAILED: 'failed',
    STOPPED: 'stopped',
});

export const RIGHT_PANEL_VIEW = Object.freeze({
    INSTRUCTIONS: 'INSTRUCTIONS_VIEW',
    STEP_EDITOR: 'STEP_EDITOR_VIEW',
    EXECUTION: 'EXECUTION_VIEW',
});

export const REPLAY_STEP_STATUS = Object.freeze({
    NEW: 'New',
    PENDING: 'Pending',
    IN_PROGRESS: 'In-Progress',
    PASSED: 'Passed',
    FAILED: 'Failed',
    SKIPPED: 'Skipped',
});

/** executeSave return value when the link-to-test-case modal replaces the confirm modal. */
export const SAVE_OPENED_LINK_TEST_CASE_POPUP = 'linkTestCasePopupOpened';

/** SaveExecutionRecord popup variants — shared with link-save utils. */
export const SAVE_POPUP_VARIANT = Object.freeze({
    DEFAULT: 'default',
    INSTRUCTIONS_ONLY: 'instructionsOnly',
});
